var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "198.127px",
    height: "198.128px",
    viewBox: "0 0 198.127 198.128",
    enableBackground: "new 0 0 198.127 198.128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #y{\n            stroke-dashoffset: 400;\n            stroke-dasharray: 400;\n            stroke-width: 2;\n        }\n        #o{\n            \n            stroke-width: 2;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "#1FD5B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopOpacity: 1,
    stopColor: "#1FD5B9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;1;0",
    repeatCount: "indefinite",
    dur: "4s",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopOpacity: 0,
    stopColor: "#1FD5B9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;1;0",
    repeatCount: "indefinite",
    dur: "4s",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#1FD5B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "#1FD5B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopOpacity: 1,
    stopColor: "#1FD5B9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;1;0",
    repeatCount: "indefinite",
    dur: "4s",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopOpacity: 0,
    stopColor: "#1FD5B9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;1;0",
    repeatCount: "indefinite",
    dur: "4s",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#1FD5B9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "y",
    fill: "url(#lg)",
    stroke: "#1FD5B9",
    d: "M154.69,65.201l-46.474,55.856v31.583c0,2.619-1.525,4.136-4.145,4.136h-9.928             c-2.757,0-4.136-1.517-4.136-4.136v-31.312L43.53,65.201c-2.206-2.627-1.107-4.962,2.343-4.962h12.966             c2.067,0,3.717,0.681,4.962,2.61l35.719,44.273l35.726-44.273c1.24-1.93,2.895-2.61,4.963-2.61h12.005             C155.66,60.239,156.758,62.574,154.69,65.201"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 400,
    to: 0,
    begin: "1s",
    dur: "2s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    id: "o",
    fill: "url(#ag)",
    stroke: "#1FD5B9",
    d: "M88.549,64.094v-6.462c0-5.141,2.903-7.975,7.979-7.975h6.722c5.081,0,7.979,2.833,7.979,7.975v6.462             c0,5.011-2.898,7.983-7.979,7.983h-6.722C91.452,72.077,88.549,69.105,88.549,64.094"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.27a8bb89af19052bd8f3de9ddd552f05.svg";
export { ForwardRef as ReactComponent };